import { flow } from 'lodash';
import { NAME } from './dialogs.constant';

import { selectState as selectStatePDV } from '../slips.selector';

const selectStateKey = (state) => state[NAME];

export const selectState = flow(selectStatePDV, selectStateKey);
